import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'account.coupons',
    defaultMessage: 'Vouchers',
  },
  subtitle: {
    id: 'account.coupons.subtitle',
    defaultMessage:
      'All of your valid e-vouchers for use in the NI Online Shop',
  },
  faq: {
    id: 'account.coupons.faq',
    defaultMessage: `<h3>How to redeem an e-voucher:</h3><ol><li>Copy the e-voucher code</li><li>Add an eligible product to the shopping cart</li><li>On the shipping cart page, enter the e-voucher code and click redeem</li></ol><h3>Which products are eligible for use with the e-voucher?</h3><p>Please see the <a>e-voucher terms and conditions</a>.</p>`,
  },
  empty: {
    id: 'account.coupons.empty',
    defaultMessage: "You currently don't have any valid e-vouchers",
  },
  emptyInstructions: {
    id: 'account.coupons.empty.instructions',
    defaultMessage:
      '<h4>Please note:</h4><ul><li>E-vouchers are issued after an eligible purchased product is registered</li><li>Allow up to 24 hours after you registered your NI product for new e-vouchers to appear here</li><li>Expired e-vouchers are automatically removed after expiry date</li></ul>',
  },
  couponTitle: {
    id: 'account.coupons.coupon.title',
    defaultMessage: 'Title',
  },
  couponCode: {
    id: 'account.coupons.coupon.code',
    defaultMessage: 'E-Voucher',
  },
  couponValidFrom: {
    id: 'account.coupons.coupon.validFrom',
    defaultMessage: 'Valid from',
  },
  couponValidUntil: {
    id: 'account.coupons.coupon.validUntil',
    defaultMessage: 'Valid until',
  },
});

/* eslint-disable react/display-name */
export const FormattedMessageEmptyInstructions: FC = () => (
  <FormattedMessage
    {...messages.emptyInstructions}
    values={{
      h4: (message: string) => <h4>{message}</h4>,
      ul: (message: string) => <ul>{message}</ul>,
      li: (message: string) => <li>{message}</li>,
    }}
  />
);

export const FormattedMessageFAQ: FC = () => {
  const { language = 'en' } = useParams<{ language?: string }>();
  return (
    <FormattedMessage
      {...messages.faq}
      values={{
        ol: (message: string) => <ol>{message}</ol>,
        li: (message: string) => <li>{message}</li>,
        h3: (message: string) => <h3>{message}</h3>,
        p: (message: string) => <p>{message}</p>,
        a: (message: string) => (
          <a href={`/${language}/support/e-voucher-terms-and-conditions-2018/`}>
            {message}
          </a>
        ),
      }}
    />
  );
};
/* eslint-enable react/display-name */

export default messages;
